module.exports = __webpack_public_path__ + "static/media/pig.ab2afd6a.svg";